import React, { useContext } from 'react'
import ReactPaginate from 'react-paginate'
import SuperAdminContext from '../../../hooks/SuperAdminContext'

const SuperAdminPagination = () => {
    const {
        paginationpageCount, currentPage,
        setCurrentPage, getJobDashboard,
        getAdminDashboard, jobApplyFilterObject,
        professionalApplyFilterObject, getEmployerDashboard,
        employerApplyFilterObject, getPartnerDashboard,
        partnerApplyFilterObject, professionalSortBy,
        employerSortBy, jobsSortBy, partnerSortBy,
        isSearched, isMilleSearchFiltered, handleAdminProfessionalMeilisearch,
        handleAdminEmployerlMeilisearch,
        handleAdminJobslMeilisearch,
        handleAdminPartnerMeilisearch

    } = useContext(SuperAdminContext);


    const handlePageClick = (value) => {
        setCurrentPage(value.selected)

        switch (window.location.pathname) {
            case "/super_admin/professional":
                if (isMilleSearchFiltered || isSearched) {
                    handleAdminProfessionalMeilisearch(professionalApplyFilterObject, undefined, value.selected)
                }
                else {
                    getAdminDashboard(undefined, value.selected, professionalSortBy);
                }
                break;

            case "/super_admin/employer":
                if (isMilleSearchFiltered || isSearched) {
                    handleAdminEmployerlMeilisearch(employerApplyFilterObject, value.selected)
                }
                else {
                    getEmployerDashboard(undefined, value.selected, employerSortBy);
                }
                break;

            case "/super_admin/jobs":
                if (isMilleSearchFiltered || isSearched) {
                    handleAdminJobslMeilisearch(jobApplyFilterObject, value.selected)
                }
                else {
                    getJobDashboard(undefined, value.selected, jobsSortBy);
                }
                break;

            case "/super_admin/partner":
                if (isMilleSearchFiltered || isSearched) {
                    handleAdminPartnerMeilisearch(partnerApplyFilterObject, value.selected)
                }
                else {
                    getPartnerDashboard(undefined, value.selected, partnerSortBy);
                }
                break;
            default:
                break;
        }
    }

    return (
        <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={'...'}
            pageCount={paginationpageCount}
            forcePage={currentPage}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            onPageChange={handlePageClick}
            containerClassName={"pagination col-12 justify-content-center mb-0"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link "}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
        />
    )
}

export default SuperAdminPagination